module.exports = __webpack_public_path__ + "img/sld_abt_check_t1_dark.e5881d04.svg";